export const imgList: Record<string, { pc: string; h5: string }[]> = {
    eu: [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711780929758/DP_wn.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711780973911/EU-en-1jpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711780947511/DPEB_%E5%B0%8F%E6%8E%A8%E8%BD%A6.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711780983480/EU-en-2jpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711780957840/BP2000_WN_Smart_Campinglight.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711780994301/EU-en-3jpg.jpg',
        },
    ],
    fr: [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711780141240/EU-FR-1jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711780212419/fr-1jpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711780163104/EU-FR-2jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711780227782/fr-2jpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711780178665/EU-FR-3jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711780242108/fr-3jpg.jpg',
        },
    ],
    de: [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711781015012/EU-ES%20%26%20DE%20%26%20IT-1jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711781107715/ES%20%26%20DE%20%26%20IT-1jpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711781035723/EU-ES%20%26%20DE%20%26%20IT-2jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711781127103/ES%20%26%20DE%20%26%20IT-2jpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711781089674/EU-ES%20%26%20DE%20%26%20IT-3jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711781141009/ES%20%26%20DE%20%26%20IT-3jpg.jpg',
        },
    ],
    it: [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711781015012/EU-ES%20%26%20DE%20%26%20IT-1jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711781107715/ES%20%26%20DE%20%26%20IT-1jpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711781035723/EU-ES%20%26%20DE%20%26%20IT-2jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711781127103/ES%20%26%20DE%20%26%20IT-2jpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711781089674/EU-ES%20%26%20DE%20%26%20IT-3jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711781141009/ES%20%26%20DE%20%26%20IT-3jpg.jpg',
        },
    ],
    es: [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711781015012/EU-ES%20%26%20DE%20%26%20IT-1jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711781107715/ES%20%26%20DE%20%26%20IT-1jpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711781035723/EU-ES%20%26%20DE%20%26%20IT-2jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711781127103/ES%20%26%20DE%20%26%20IT-2jpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711781089674/EU-ES%20%26%20DE%20%26%20IT-3jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711781141009/ES%20%26%20DE%20%26%20IT-3jpg.jpg',
        },
    ],
    uk: [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711249727997/pc-pic-1jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711249773435/mo-pic-1jpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711249796634/pc-pic-2jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711249817579/mo-pic-2jpg.jpg',
        },
    ],
    us: [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711269593274/pic-1-PCjpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711269722110/pic-1-MOjpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711269671623/pic-2-PCjpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711269748588/pic-2-MOjpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711510584793/NA-PCjpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711510607108/NA-mojpg.jpg',
        },
    ],
    ca: [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711269593274/pic-1-PCjpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711269722110/pic-1-MOjpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711269671623/pic-2-PCjpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711269748588/pic-2-MOjpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711510584793/NA-PCjpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711510607108/NA-mojpg.jpg',
        },
    ],
    za: [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711596340992/R2P%2B160W%2BBag-pc.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711596512584/R2P%2B160W%2BBag-m.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711596569116/D2M%2B400W%2BBag-pc.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711596603139/D2M%2B400W%2BBag-m.jpg',
        },
    ],
    kr: [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1712485060955/kr-pic-PCjpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1712485092251/kr-pic-mojpg.jpg',
        },
    ],
};

export const imgList2: Record<string, { pc: string; h5: string }[]> = {
    eu: [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711784535063/EU-En-1jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711784617022/EU-en-1jpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711784566708/EU-En-2jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711784626919/EU-en-2jpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711784579462/DM_1600_camping_light.png',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711784637371/DM_1600_camping%20light.png',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711784592629/DM_2000_camping_light.png',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711784647382/DM_2000_camping%20light.png',
        },
    ],
    uk: [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711784294819/UK-1jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711784339473/uk-en-1jpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711784320362/UK-2jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711784349302/uk-en-2jpg.jpg',
        },
    ],
    fr: [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711784394201/EU-FR-1jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711784479609/fr-1jpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711784414587/EU-FR-2jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711784489657/fr-2jpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711784446947/DM_1600_camping_light.png',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711784500115/DM_1600_camping%20light.png',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711784456475/DM_2000_camping_light.png',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711784510834/DM_2000_camping%20light.png',
        },
    ],
    de: [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711784695322/DP_WN.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711785458590/ES%20%26%20DE%20%26%20IT-1jpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711785417695/DPEB_%E6%89%8B%E6%8E%A8%E8%BD%A6.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711785467493/ES%20%26%20DE%20%26%20IT-2jpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711785428375/DM_1600_camping_light.png',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711785478502/DM_1600_camping%20light.png',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711785439121/DM_2000_camping_light.png',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711785488393/DM_2000_camping%20light.png',
        },
    ],
    es: [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711784695322/DP_WN.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711785458590/ES%20%26%20DE%20%26%20IT-1jpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711785417695/DPEB_%E6%89%8B%E6%8E%A8%E8%BD%A6.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711785467493/ES%20%26%20DE%20%26%20IT-2jpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711785428375/DM_1600_camping_light.png',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711785478502/DM_1600_camping%20light.png',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711785439121/DM_2000_camping_light.png',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711785488393/DM_2000_camping%20light.png',
        },
    ],
    it: [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711784695322/DP_WN.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711785458590/ES%20%26%20DE%20%26%20IT-1jpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711785417695/DPEB_%E6%89%8B%E6%8E%A8%E8%BD%A6.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711785467493/ES%20%26%20DE%20%26%20IT-2jpg.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711785428375/DM_1600_camping_light.png',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711785478502/DM_1600_camping%20light.png',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711785439121/DM_2000_camping_light.png',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711785488393/DM_2000_camping%20light.png',
        },
    ],
};

export const imgList3: Record<string, { pc: string; h5: string }[]> = {
    eu: [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711780957840/BP2000_WN_Smart_Campinglight.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711780994301/EU-en-3jpg.jpg',
        },
    ],
    fr: [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711780178665/EU-FR-3jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711780242108/fr-3jpg.jpg',
        },
    ],
    de: [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711781089674/EU-ES%20%26%20DE%20%26%20IT-3jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711781141009/ES%20%26%20DE%20%26%20IT-3jpg.jpg',
        },
    ],
    it: [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711781089674/EU-ES%20%26%20DE%20%26%20IT-3jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711781141009/ES%20%26%20DE%20%26%20IT-3jpg.jpg',
        },
    ],
    es: [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711781089674/EU-ES%20%26%20DE%20%26%20IT-3jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711781141009/ES%20%26%20DE%20%26%20IT-3jpg.jpg',
        },
    ],
};
